
import HomeBanner from "./HomeBanner";
import HomeIntro from "./HomeIntro";
import HomeServices from "./HomeServices";
import HomeWhyChooseUse from "./HomeWhyChooseUs";
import HomeTestimonials from "./HomeTestimonials";
function HomePage(){
    return(
        <>
            <HomeBanner/>
            <HomeIntro/>
            <HomeServices/>
            <HomeWhyChooseUse/>            
            <HomeTestimonials/>
        </>
    );
}

export default HomePage;